import { isSewer } from '../lib/profiles';
import { feat } from '../lib/features';
import MaskToggle from './MaskToggle';
import { useEffect, useState } from 'react';
import { Eye, X } from 'lucide-react';
import { useVis, setVis, VIS_KEYS } from '../lib/vis';
// layers that only exist with their tool switched on
const NEED = { loggers: 'loggers', noise: 'loggers', tracks: 'tracks' };

export default function VisMenu({ t }) {
  const [open, setOpen] = useState(false);
  const v = useVis();
  useEffect(() => {
    const on = () => setOpen(true);
    window.addEventListener('giss-vis-menu', on);
    return () => window.removeEventListener('giss-vis-menu', on);
  }, []);
  useEffect(() => { if (!open) return undefined; const k = (e) => e.key === 'Escape' && setOpen(false); window.addEventListener('keydown', k); return () => window.removeEventListener('keydown', k); }, [open]);
  if (!open) return null;
  const all = (on) => setVis(Object.fromEntries(VIS_KEYS.map((k) => [k, on])));
  return (
    <div className="vis-menu mask" data-testid="vis-menu">
      <div className="ov-panel-head mask-keep"><b><Eye size={14} /> {t.visTitle}</b><MaskToggle t={t} id="vismenu" /><button className="icon-btn" data-testid="vis-menu-close" onClick={() => setOpen(false)}><X size={14} /></button></div>
      <div className="ov-panel-row">
        <button className="btn btn-dark btn-sm" data-testid="vis-all-on" onClick={() => all(true)}>{t.visAllOn}</button>
        <button className="btn btn-outline btn-sm" data-testid="vis-all-off" onClick={() => all(false)}>{t.visAllOff}</button>
      </div>
      <div className="ui-checks">
        {VIS_KEYS.filter((k) => !NEED[k] || feat(NEED[k])).filter((k) => !isSewer() || ['sewer', 'otherPipes', 'fittings', 'leaks', 'pits', 'dims', 'tracks', 'cad'].includes(k)).map((k) => <label key={k}><input type="checkbox" data-testid={`vis-check-${k}`} checked={v[k]} onChange={(e) => setVis({ [k]: e.target.checked })} /> {t['vis_' + k]}</label>)}
      </div>
      <p className="gnss-hint">{t.visHint}</p>
    </div>
  );
}
